// Числовые поля. Браузерный type="number" считает "2," незавершённым числом
// и отдаёт пустое значение, поэтому поле работает как текст с цифровой клавиатурой.
export const NUMBER_RULE = 'number_format';

const MAX_INTEGER_DIGITS = 16;
const MAX_FRACTION_DIGITS = 10;
const PARTIAL_NUMBER = /^-?\d*\.?\d*$/;

export function cleanNumber(raw, unsigned) {
  const text = String(raw).replace(/,/g, '.').replace(/[^\d.-]/g, '');
  const sign = !unsigned && text.startsWith('-') ? '-' : '';
  const [integer, ...fraction] = text.replace(/-/g, '').split('.');

  return sign + integer + (fraction.length ? `.${fraction.join('')}` : '');
}

// То же, что делал браузер: нечисловое значение (например, скрытое сервером) не показываем
export function shownNumber(value) {
  if (value === null || value === undefined || value === '') return value;

  const text = String(value);

  return PARTIAL_NUMBER.test(text) || Number.isFinite(Number(text)) ? value : '';
}

export function isValidNumber(value) {
  const text = String(value).trim();

  if (!PARTIAL_NUMBER.test(text) || !/\d/.test(text)) return false;

  const [integer, fraction = ''] = text.replace('-', '').split('.');

  return integer.length <= MAX_INTEGER_DIGITS && fraction.length <= MAX_FRACTION_DIGITS;
}

export function withNumberRule(rules) {
  if (rules && typeof rules === 'object') return { [NUMBER_RULE]: true, ...rules };

  return rules ? `${NUMBER_RULE}|${rules}` : NUMBER_RULE;
}
